<template>
  <div id="signIn">
    <section>
      <transition name="fade">
        <div v-if="showActivityIndicator" class="loading">
          <p>Signing in...</p>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="errorMessage.length > 0" class="errorMessage">
          <div>
            <p>{{ errorMessage }}</p>
            <button v-on:click="errorMessage = ''">OK</button>
          </div>
        </div>
      </transition>

      <!-- Number Input Form -->
      <template v-if="showPhoneNumberInput">
        <form v-on:submit.prevent>
            <p>Country code</p>
            <input type="text" v-model="phoneNumberInputForm.country" placeholder="Country code (+1 for USA)" required/>
            <p>Phone number</p>
            <input type="text" v-model="phoneNumberInputForm.number" placeholder="Phone number" required autofocus/>
            <button type="submit" id="get-sign-in-code" :disabled="this.disableUI">{{ this.disableUI ? "Initializing..." : "Sign In" }}</button>
        </form>
      </template>

      <!-- SMS Verification Form -->
      <template v-if="showVerificationCodeInput">
        <form v-on:submit.prevent>
            <p>Verification code</p>
            <input type="text" v-model="verificationCodeInputForm.code" placeholder="Verification Code" required autofocus/>
            <button type="submit" :disabled="this.disableUI" v-on:click="verifySignInWithCode()">{{ this.disableUI ? "Initializing..." : "Verify" }}</button>
        </form>
      </template>
    </section>
  </div>
</template>

<script>
  const fb = require("../firebaseConfig.js")

  export default {
    name: "SignIn",

    data() {
      return {
        recaptchaVerifier: null,

        // UI States
        showPhoneNumberInput: true,
        showVerificationCodeInput: false,

        // Forms
        phoneNumberInputForm: { country: "", number: "" },
        verificationCodeInputForm: { code: "" },

        showActivityIndicator: false,
        errorMessage: "",
        disableUI: false,
        confirmationResult: null
      }
    },

    mounted() {
      const self = this

      self.disableUI = true

      // Kick off the recaptcha verifier on page load
      self.recaptchaVerifier = new fb.authModule.RecaptchaVerifier( "get-sign-in-code", { size: "invisible", callback: () => { self.signIn() }})
      self.recaptchaVerifier.render().then(widgetId => {
        console.log("RecaptchaVerifier rendering done!")
        self.disableUI = false

        window.recaptchaWidgetId = widgetId
      })

      if (this.$route.params.country) {
        self.phoneNumberInputForm.country = this.$route.params.country
      }
      else {
        self.phoneNumberInputForm.country = "+1"
      }
      if (this.$route.params.phone) {
        self.phoneNumberInputForm.number = this.$route.params.phone
      }
    },

    methods: {
      signIn() {
        const self = this

        const phoneNumber = self.phoneNumberInputForm.country + self.phoneNumberInputForm.number
        console.log(`signInWithPhoneNumber starting for number: ${phoneNumber}`)
        self.showActivityIndicator = true
        self.disableUI = true

        fb.auth.signInWithPhoneNumber(phoneNumber, self.recaptchaVerifier).then(confirmationResult => {
          console.log(`signInWithPhoneNumber finished with result: ${confirmationResult.verificationId}`)

          self.confirmationResult = confirmationResult

          self.showPhoneNumberInput = false
          self.showVerificationCodeInput = true

          self.showActivityIndicator = false
          self.disableUI = false
        }).catch(function(error) {
          console.error("Error during signInWithPhoneNumber", error)

          self.showActivityIndicator = false
          self.disableUI = false

          self.errorMessage = "Error: Phone number isn't valid."
        })
      },
      verifySignInWithCode() {
        const self = this

        console.log(`confirmationResult.confirm starting for code: ${self.verificationCodeInputForm.code}`)
        self.showActivityIndicator = true
        self.disableUI = true

        self.confirmationResult.confirm(self.verificationCodeInputForm.code).then(result => {
          console.log(`USER ID: ${result.user.uid}`)
          self.$store.commit('setAuthUser', result.user)
          self.$store.dispatch('updateAppUserEnvironment', { environment: { platform: `Web ${platform.os.toString()}`, appVersion: `1.0` } })
          self.$store.dispatch('updateAppUserSignedIn', { isSignedIn: true })
          self.$store.dispatch('updateAppUserLastSignInOutDateTime', { lastSignInOutDateTime: Date() })
          self.$store.dispatch('fetchAppUser')

          self.showActivityIndicator = false
          self.disableUI = false

          self.confirmationResult = null

          self.$router.push('/events')
        }).catch(function (error) {
          console.error('Error while checking the verification code', error)

          self.showActivityIndicator = false
          self.disableUI = false

          self.errorMessage = "Error: Verification code isn't valid."

          window.alert('Error while checking the verification code:\n\n' + error.code + '\n\n' + error.message)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SignIn.vue